/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as UserFilterRouteImport } from './routes/user-filter'
import { Route as TicketsRouteImport } from './routes/tickets'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as SearchLocationRouteImport } from './routes/search-location'
import { Route as RoleSelectionRouteImport } from './routes/role-selection'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PersonalInformationRouteImport } from './routes/personal-information'
import { Route as PasswordResetSuccessRouteImport } from './routes/password-reset-success'
import { Route as MusicStyleRouteImport } from './routes/music-style'
import { Route as MessagesRouteImport } from './routes/messages'
import { Route as MediaRouteImport } from './routes/media'
import { Route as MailRouteImport } from './routes/mail'
import { Route as HelpSupportRouteImport } from './routes/help-support'
import { Route as GigsRouteImport } from './routes/gigs'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as EventsRouteImport } from './routes/events'
import { Route as CommunityGuidelinesRouteImport } from './routes/community-guidelines'
import { Route as CheckEmailRouteImport } from './routes/check-email'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ProjectsIndexRouteImport } from './routes/projects.index'
import { Route as ProfileIndexRouteImport } from './routes/profile.index'
import { Route as MediaIndexRouteImport } from './routes/media.index'
import { Route as MailIndexRouteImport } from './routes/mail.index'
import { Route as GigsIndexRouteImport } from './routes/gigs.index'
import { Route as EventsIndexRouteImport } from './routes/events.index'
import { Route as ServicesCreateRouteImport } from './routes/services.create'
import { Route as ServicesServiceIdRouteImport } from './routes/services.$serviceId'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects.$projectId'
import { Route as ProfileSettingsRouteImport } from './routes/profile.settings'
import { Route as ProfilePreferredLocationsRouteImport } from './routes/profile.preferred-locations'
import { Route as ProfileMyGigsRouteImport } from './routes/profile.my-gigs'
import { Route as ProfileGigRequestsRouteImport } from './routes/profile.gig-requests'
import { Route as ProfileEditRouteImport } from './routes/profile.edit'
import { Route as ProfileChangePasswordRouteImport } from './routes/profile.change-password'
import { Route as ProfileIdentifierRouteImport } from './routes/profile.$identifier'
import { Route as OffersCreateRouteImport } from './routes/offers.create'
import { Route as OffersOfferIdRouteImport } from './routes/offers.$offerId'
import { Route as MediaCreateRouteImport } from './routes/media.create'
import { Route as MediaMediaIdRouteImport } from './routes/media.$mediaId'
import { Route as MailContactsRouteImport } from './routes/mail.contacts'
import { Route as MailComposeRouteImport } from './routes/mail.compose'
import { Route as GigsCreateRouteImport } from './routes/gigs.create'
import { Route as GigsGigIdRouteImport } from './routes/gigs.$gigId'
import { Route as EventsYoursRouteImport } from './routes/events.yours'
import { Route as EventsPublicRouteImport } from './routes/events.public'
import { Route as EventsCreateRouteImport } from './routes/events.create'
import { Route as EventsEventIdRouteImport } from './routes/events.$eventId'
import { Route as Embedded_checkout_pageEventIdRouteImport } from './routes/embedded_checkout_page.$eventId'
import { Route as CheckoutCancelRouteImport } from './routes/checkout.cancel'
import { Route as ProfileSettingsIndexRouteImport } from './routes/profile.settings.index'
import { Route as EventsCreateIndexRouteImport } from './routes/events.create.index'
import { Route as ServicesServiceIdEditRouteImport } from './routes/services.$serviceId.edit'
import { Route as ProjectsProjectIdNotificationsRouteImport } from './routes/projects.$projectId.notifications'
import { Route as ProjectsProjectIdEditRouteImport } from './routes/projects.$projectId.edit'
import { Route as ProfileSettingsUserTypeRouteImport } from './routes/profile.settings.user-type'
import { Route as ProfileSettingsTagsRouteImport } from './routes/profile.settings.tags'
import { Route as ProfileSettingsSubscriptionsRouteImport } from './routes/profile.settings.subscriptions'
import { Route as ProfileSettingsShareableLinkRouteImport } from './routes/profile.settings.shareable-link'
import { Route as ProfileSettingsPaymentsRouteImport } from './routes/profile.settings.payments'
import { Route as ProfileSettingsGenresRouteImport } from './routes/profile.settings.genres'
import { Route as OffersOfferIdSharedLinkRouteImport } from './routes/offers.$offerId.shared-link'
import { Route as OffersOfferIdEditRouteImport } from './routes/offers.$offerId.edit'
import { Route as OffersOfferIdChatRouteImport } from './routes/offers.$offerId.chat'
import { Route as MediaMediaIdEditRouteImport } from './routes/media.$mediaId.edit'
import { Route as MailListsListUuidRouteImport } from './routes/mail.lists.$listUuid'
import { Route as MailBroadcastsBroadcastUuidRouteImport } from './routes/mail.broadcasts.$broadcastUuid'
import { Route as GigsGigIdEditRouteImport } from './routes/gigs.$gigId.edit'
import { Route as EventsCreateSingleRouteImport } from './routes/events.create.single'
import { Route as EventsCreateExternalRouteImport } from './routes/events.create.external'
import { Route as EventsCategoryFilterNameRouteImport } from './routes/events.category.$filterName'
import { Route as EventsEventIdSuccessRouteImport } from './routes/events.$eventId.success'
import { Route as EventsEventIdEditExternalRouteImport } from './routes/events.$eventId.edit-external'
import { Route as EventsEventIdEditRouteImport } from './routes/events.$eventId.edit'
import { Route as EventsEventIdCheckoutRouteImport } from './routes/events.$eventId.checkout'

const IndexLazyRouteImport = createFileRoute('/')()

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const UserFilterRoute = UserFilterRouteImport.update({
  id: '/user-filter',
  path: '/user-filter',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsRoute = TicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesRoute = ServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchLocationRoute = SearchLocationRouteImport.update({
  id: '/search-location',
  path: '/search-location',
  getParentRoute: () => rootRouteImport,
} as any)
const RoleSelectionRoute = RoleSelectionRouteImport.update({
  id: '/role-selection',
  path: '/role-selection',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalInformationRoute = PersonalInformationRouteImport.update({
  id: '/personal-information',
  path: '/personal-information',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetSuccessRoute = PasswordResetSuccessRouteImport.update({
  id: '/password-reset-success',
  path: '/password-reset-success',
  getParentRoute: () => rootRouteImport,
} as any)
const MusicStyleRoute = MusicStyleRouteImport.update({
  id: '/music-style',
  path: '/music-style',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesRoute = MessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaRoute = MediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => rootRouteImport,
} as any)
const MailRoute = MailRouteImport.update({
  id: '/mail',
  path: '/mail',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpSupportRoute = HelpSupportRouteImport.update({
  id: '/help-support',
  path: '/help-support',
  getParentRoute: () => rootRouteImport,
} as any)
const GigsRoute = GigsRouteImport.update({
  id: '/gigs',
  path: '/gigs',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsRoute = EventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunityGuidelinesRoute = CommunityGuidelinesRouteImport.update({
  id: '/community-guidelines',
  path: '/community-guidelines',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckEmailRoute = CheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const ServicesIndexRoute = ServicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ServicesRoute,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProfileRoute,
} as any)
const MediaIndexRoute = MediaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MediaRoute,
} as any)
const MailIndexRoute = MailIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MailRoute,
} as any)
const GigsIndexRoute = GigsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GigsRoute,
} as any)
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EventsRoute,
} as any)
const ServicesCreateRoute = ServicesCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => ServicesRoute,
} as any)
const ServicesServiceIdRoute = ServicesServiceIdRouteImport.update({
  id: '/$serviceId',
  path: '/$serviceId',
  getParentRoute: () => ServicesRoute,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/$projectId',
  path: '/$projectId',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProfileSettingsRoute = ProfileSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfilePreferredLocationsRoute =
  ProfilePreferredLocationsRouteImport.update({
    id: '/preferred-locations',
    path: '/preferred-locations',
    getParentRoute: () => ProfileRoute,
  } as any)
const ProfileMyGigsRoute = ProfileMyGigsRouteImport.update({
  id: '/my-gigs',
  path: '/my-gigs',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileGigRequestsRoute = ProfileGigRequestsRouteImport.update({
  id: '/gig-requests',
  path: '/gig-requests',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileEditRoute = ProfileEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileChangePasswordRoute = ProfileChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileIdentifierRoute = ProfileIdentifierRouteImport.update({
  id: '/$identifier',
  path: '/$identifier',
  getParentRoute: () => ProfileRoute,
} as any)
const OffersCreateRoute = OffersCreateRouteImport.update({
  id: '/offers/create',
  path: '/offers/create',
  getParentRoute: () => rootRouteImport,
} as any)
const OffersOfferIdRoute = OffersOfferIdRouteImport.update({
  id: '/offers/$offerId',
  path: '/offers/$offerId',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaCreateRoute = MediaCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => MediaRoute,
} as any)
const MediaMediaIdRoute = MediaMediaIdRouteImport.update({
  id: '/$mediaId',
  path: '/$mediaId',
  getParentRoute: () => MediaRoute,
} as any)
const MailContactsRoute = MailContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => MailRoute,
} as any)
const MailComposeRoute = MailComposeRouteImport.update({
  id: '/compose',
  path: '/compose',
  getParentRoute: () => MailRoute,
} as any)
const GigsCreateRoute = GigsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => GigsRoute,
} as any)
const GigsGigIdRoute = GigsGigIdRouteImport.update({
  id: '/$gigId',
  path: '/$gigId',
  getParentRoute: () => GigsRoute,
} as any)
const EventsYoursRoute = EventsYoursRouteImport.update({
  id: '/yours',
  path: '/yours',
  getParentRoute: () => EventsRoute,
} as any)
const EventsPublicRoute = EventsPublicRouteImport.update({
  id: '/public',
  path: '/public',
  getParentRoute: () => EventsRoute,
} as any)
const EventsCreateRoute = EventsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => EventsRoute,
} as any)
const EventsEventIdRoute = EventsEventIdRouteImport.update({
  id: '/$eventId',
  path: '/$eventId',
  getParentRoute: () => EventsRoute,
} as any)
const Embedded_checkout_pageEventIdRoute =
  Embedded_checkout_pageEventIdRouteImport.update({
    id: '/embedded_checkout_page/$eventId',
    path: '/embedded_checkout_page/$eventId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CheckoutCancelRoute = CheckoutCancelRouteImport.update({
  id: '/checkout/cancel',
  path: '/checkout/cancel',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileSettingsIndexRoute = ProfileSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProfileSettingsRoute,
} as any)
const EventsCreateIndexRoute = EventsCreateIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EventsCreateRoute,
} as any)
const ServicesServiceIdEditRoute = ServicesServiceIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ServicesServiceIdRoute,
} as any)
const ProjectsProjectIdNotificationsRoute =
  ProjectsProjectIdNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdEditRoute = ProjectsProjectIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ProjectsProjectIdRoute,
} as any)
const ProfileSettingsUserTypeRoute = ProfileSettingsUserTypeRouteImport.update({
  id: '/user-type',
  path: '/user-type',
  getParentRoute: () => ProfileSettingsRoute,
} as any)
const ProfileSettingsTagsRoute = ProfileSettingsTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => ProfileSettingsRoute,
} as any)
const ProfileSettingsSubscriptionsRoute =
  ProfileSettingsSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => ProfileSettingsRoute,
  } as any)
const ProfileSettingsShareableLinkRoute =
  ProfileSettingsShareableLinkRouteImport.update({
    id: '/shareable-link',
    path: '/shareable-link',
    getParentRoute: () => ProfileSettingsRoute,
  } as any)
const ProfileSettingsPaymentsRoute = ProfileSettingsPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => ProfileSettingsRoute,
} as any)
const ProfileSettingsGenresRoute = ProfileSettingsGenresRouteImport.update({
  id: '/genres',
  path: '/genres',
  getParentRoute: () => ProfileSettingsRoute,
} as any)
const OffersOfferIdSharedLinkRoute = OffersOfferIdSharedLinkRouteImport.update({
  id: '/shared-link',
  path: '/shared-link',
  getParentRoute: () => OffersOfferIdRoute,
} as any)
const OffersOfferIdEditRoute = OffersOfferIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => OffersOfferIdRoute,
} as any)
const OffersOfferIdChatRoute = OffersOfferIdChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => OffersOfferIdRoute,
} as any)
const MediaMediaIdEditRoute = MediaMediaIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => MediaMediaIdRoute,
} as any)
const MailListsListUuidRoute = MailListsListUuidRouteImport.update({
  id: '/lists/$listUuid',
  path: '/lists/$listUuid',
  getParentRoute: () => MailRoute,
} as any)
const MailBroadcastsBroadcastUuidRoute =
  MailBroadcastsBroadcastUuidRouteImport.update({
    id: '/broadcasts/$broadcastUuid',
    path: '/broadcasts/$broadcastUuid',
    getParentRoute: () => MailRoute,
  } as any)
const GigsGigIdEditRoute = GigsGigIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => GigsGigIdRoute,
} as any)
const EventsCreateSingleRoute = EventsCreateSingleRouteImport.update({
  id: '/single',
  path: '/single',
  getParentRoute: () => EventsCreateRoute,
} as any)
const EventsCreateExternalRoute = EventsCreateExternalRouteImport.update({
  id: '/external',
  path: '/external',
  getParentRoute: () => EventsCreateRoute,
} as any)
const EventsCategoryFilterNameRoute =
  EventsCategoryFilterNameRouteImport.update({
    id: '/category/$filterName',
    path: '/category/$filterName',
    getParentRoute: () => EventsRoute,
  } as any)
const EventsEventIdSuccessRoute = EventsEventIdSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => EventsEventIdRoute,
} as any)
const EventsEventIdEditExternalRoute =
  EventsEventIdEditExternalRouteImport.update({
    id: '/edit-external',
    path: '/edit-external',
    getParentRoute: () => EventsEventIdRoute,
  } as any)
const EventsEventIdEditRoute = EventsEventIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => EventsEventIdRoute,
} as any)
const EventsEventIdCheckoutRoute = EventsEventIdCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => EventsEventIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/check-email': typeof CheckEmailRoute
  '/community-guidelines': typeof CommunityGuidelinesRoute
  '/events': typeof EventsRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/gigs': typeof GigsRouteWithChildren
  '/help-support': typeof HelpSupportRoute
  '/mail': typeof MailRouteWithChildren
  '/media': typeof MediaRouteWithChildren
  '/messages': typeof MessagesRoute
  '/music-style': typeof MusicStyleRoute
  '/password-reset-success': typeof PasswordResetSuccessRoute
  '/personal-information': typeof PersonalInformationRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/profile': typeof ProfileRouteWithChildren
  '/projects': typeof ProjectsRouteWithChildren
  '/role-selection': typeof RoleSelectionRoute
  '/search-location': typeof SearchLocationRoute
  '/services': typeof ServicesRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/tickets': typeof TicketsRoute
  '/user-filter': typeof UserFilterRoute
  '/verify-email': typeof VerifyEmailRoute
  '/checkout/cancel': typeof CheckoutCancelRoute
  '/embedded_checkout_page/$eventId': typeof Embedded_checkout_pageEventIdRoute
  '/events/$eventId': typeof EventsEventIdRouteWithChildren
  '/events/create': typeof EventsCreateRouteWithChildren
  '/events/public': typeof EventsPublicRoute
  '/events/yours': typeof EventsYoursRoute
  '/gigs/$gigId': typeof GigsGigIdRouteWithChildren
  '/gigs/create': typeof GigsCreateRoute
  '/mail/compose': typeof MailComposeRoute
  '/mail/contacts': typeof MailContactsRoute
  '/media/$mediaId': typeof MediaMediaIdRouteWithChildren
  '/media/create': typeof MediaCreateRoute
  '/offers/$offerId': typeof OffersOfferIdRouteWithChildren
  '/offers/create': typeof OffersCreateRoute
  '/profile/$identifier': typeof ProfileIdentifierRoute
  '/profile/change-password': typeof ProfileChangePasswordRoute
  '/profile/edit': typeof ProfileEditRoute
  '/profile/gig-requests': typeof ProfileGigRequestsRoute
  '/profile/my-gigs': typeof ProfileMyGigsRoute
  '/profile/preferred-locations': typeof ProfilePreferredLocationsRoute
  '/profile/settings': typeof ProfileSettingsRouteWithChildren
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/services/$serviceId': typeof ServicesServiceIdRouteWithChildren
  '/services/create': typeof ServicesCreateRoute
  '/events/': typeof EventsIndexRoute
  '/gigs/': typeof GigsIndexRoute
  '/mail/': typeof MailIndexRoute
  '/media/': typeof MediaIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/services/': typeof ServicesIndexRoute
  '/events/$eventId/checkout': typeof EventsEventIdCheckoutRoute
  '/events/$eventId/edit': typeof EventsEventIdEditRoute
  '/events/$eventId/edit-external': typeof EventsEventIdEditExternalRoute
  '/events/$eventId/success': typeof EventsEventIdSuccessRoute
  '/events/category/$filterName': typeof EventsCategoryFilterNameRoute
  '/events/create/external': typeof EventsCreateExternalRoute
  '/events/create/single': typeof EventsCreateSingleRoute
  '/gigs/$gigId/edit': typeof GigsGigIdEditRoute
  '/mail/broadcasts/$broadcastUuid': typeof MailBroadcastsBroadcastUuidRoute
  '/mail/lists/$listUuid': typeof MailListsListUuidRoute
  '/media/$mediaId/edit': typeof MediaMediaIdEditRoute
  '/offers/$offerId/chat': typeof OffersOfferIdChatRoute
  '/offers/$offerId/edit': typeof OffersOfferIdEditRoute
  '/offers/$offerId/shared-link': typeof OffersOfferIdSharedLinkRoute
  '/profile/settings/genres': typeof ProfileSettingsGenresRoute
  '/profile/settings/payments': typeof ProfileSettingsPaymentsRoute
  '/profile/settings/shareable-link': typeof ProfileSettingsShareableLinkRoute
  '/profile/settings/subscriptions': typeof ProfileSettingsSubscriptionsRoute
  '/profile/settings/tags': typeof ProfileSettingsTagsRoute
  '/profile/settings/user-type': typeof ProfileSettingsUserTypeRoute
  '/projects/$projectId/edit': typeof ProjectsProjectIdEditRoute
  '/projects/$projectId/notifications': typeof ProjectsProjectIdNotificationsRoute
  '/services/$serviceId/edit': typeof ServicesServiceIdEditRoute
  '/events/create/': typeof EventsCreateIndexRoute
  '/profile/settings/': typeof ProfileSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/check-email': typeof CheckEmailRoute
  '/community-guidelines': typeof CommunityGuidelinesRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/help-support': typeof HelpSupportRoute
  '/messages': typeof MessagesRoute
  '/music-style': typeof MusicStyleRoute
  '/password-reset-success': typeof PasswordResetSuccessRoute
  '/personal-information': typeof PersonalInformationRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/role-selection': typeof RoleSelectionRoute
  '/search-location': typeof SearchLocationRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/tickets': typeof TicketsRoute
  '/user-filter': typeof UserFilterRoute
  '/verify-email': typeof VerifyEmailRoute
  '/checkout/cancel': typeof CheckoutCancelRoute
  '/embedded_checkout_page/$eventId': typeof Embedded_checkout_pageEventIdRoute
  '/events/$eventId': typeof EventsEventIdRouteWithChildren
  '/events/public': typeof EventsPublicRoute
  '/events/yours': typeof EventsYoursRoute
  '/gigs/$gigId': typeof GigsGigIdRouteWithChildren
  '/gigs/create': typeof GigsCreateRoute
  '/mail/compose': typeof MailComposeRoute
  '/mail/contacts': typeof MailContactsRoute
  '/media/$mediaId': typeof MediaMediaIdRouteWithChildren
  '/media/create': typeof MediaCreateRoute
  '/offers/$offerId': typeof OffersOfferIdRouteWithChildren
  '/offers/create': typeof OffersCreateRoute
  '/profile/$identifier': typeof ProfileIdentifierRoute
  '/profile/change-password': typeof ProfileChangePasswordRoute
  '/profile/edit': typeof ProfileEditRoute
  '/profile/gig-requests': typeof ProfileGigRequestsRoute
  '/profile/my-gigs': typeof ProfileMyGigsRoute
  '/profile/preferred-locations': typeof ProfilePreferredLocationsRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/services/$serviceId': typeof ServicesServiceIdRouteWithChildren
  '/services/create': typeof ServicesCreateRoute
  '/events': typeof EventsIndexRoute
  '/gigs': typeof GigsIndexRoute
  '/mail': typeof MailIndexRoute
  '/media': typeof MediaIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/services': typeof ServicesIndexRoute
  '/events/$eventId/checkout': typeof EventsEventIdCheckoutRoute
  '/events/$eventId/edit': typeof EventsEventIdEditRoute
  '/events/$eventId/edit-external': typeof EventsEventIdEditExternalRoute
  '/events/$eventId/success': typeof EventsEventIdSuccessRoute
  '/events/category/$filterName': typeof EventsCategoryFilterNameRoute
  '/events/create/external': typeof EventsCreateExternalRoute
  '/events/create/single': typeof EventsCreateSingleRoute
  '/gigs/$gigId/edit': typeof GigsGigIdEditRoute
  '/mail/broadcasts/$broadcastUuid': typeof MailBroadcastsBroadcastUuidRoute
  '/mail/lists/$listUuid': typeof MailListsListUuidRoute
  '/media/$mediaId/edit': typeof MediaMediaIdEditRoute
  '/offers/$offerId/chat': typeof OffersOfferIdChatRoute
  '/offers/$offerId/edit': typeof OffersOfferIdEditRoute
  '/offers/$offerId/shared-link': typeof OffersOfferIdSharedLinkRoute
  '/profile/settings/genres': typeof ProfileSettingsGenresRoute
  '/profile/settings/payments': typeof ProfileSettingsPaymentsRoute
  '/profile/settings/shareable-link': typeof ProfileSettingsShareableLinkRoute
  '/profile/settings/subscriptions': typeof ProfileSettingsSubscriptionsRoute
  '/profile/settings/tags': typeof ProfileSettingsTagsRoute
  '/profile/settings/user-type': typeof ProfileSettingsUserTypeRoute
  '/projects/$projectId/edit': typeof ProjectsProjectIdEditRoute
  '/projects/$projectId/notifications': typeof ProjectsProjectIdNotificationsRoute
  '/services/$serviceId/edit': typeof ServicesServiceIdEditRoute
  '/events/create': typeof EventsCreateIndexRoute
  '/profile/settings': typeof ProfileSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/check-email': typeof CheckEmailRoute
  '/community-guidelines': typeof CommunityGuidelinesRoute
  '/events': typeof EventsRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/gigs': typeof GigsRouteWithChildren
  '/help-support': typeof HelpSupportRoute
  '/mail': typeof MailRouteWithChildren
  '/media': typeof MediaRouteWithChildren
  '/messages': typeof MessagesRoute
  '/music-style': typeof MusicStyleRoute
  '/password-reset-success': typeof PasswordResetSuccessRoute
  '/personal-information': typeof PersonalInformationRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/profile': typeof ProfileRouteWithChildren
  '/projects': typeof ProjectsRouteWithChildren
  '/role-selection': typeof RoleSelectionRoute
  '/search-location': typeof SearchLocationRoute
  '/services': typeof ServicesRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/tickets': typeof TicketsRoute
  '/user-filter': typeof UserFilterRoute
  '/verify-email': typeof VerifyEmailRoute
  '/checkout/cancel': typeof CheckoutCancelRoute
  '/embedded_checkout_page/$eventId': typeof Embedded_checkout_pageEventIdRoute
  '/events/$eventId': typeof EventsEventIdRouteWithChildren
  '/events/create': typeof EventsCreateRouteWithChildren
  '/events/public': typeof EventsPublicRoute
  '/events/yours': typeof EventsYoursRoute
  '/gigs/$gigId': typeof GigsGigIdRouteWithChildren
  '/gigs/create': typeof GigsCreateRoute
  '/mail/compose': typeof MailComposeRoute
  '/mail/contacts': typeof MailContactsRoute
  '/media/$mediaId': typeof MediaMediaIdRouteWithChildren
  '/media/create': typeof MediaCreateRoute
  '/offers/$offerId': typeof OffersOfferIdRouteWithChildren
  '/offers/create': typeof OffersCreateRoute
  '/profile/$identifier': typeof ProfileIdentifierRoute
  '/profile/change-password': typeof ProfileChangePasswordRoute
  '/profile/edit': typeof ProfileEditRoute
  '/profile/gig-requests': typeof ProfileGigRequestsRoute
  '/profile/my-gigs': typeof ProfileMyGigsRoute
  '/profile/preferred-locations': typeof ProfilePreferredLocationsRoute
  '/profile/settings': typeof ProfileSettingsRouteWithChildren
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/services/$serviceId': typeof ServicesServiceIdRouteWithChildren
  '/services/create': typeof ServicesCreateRoute
  '/events/': typeof EventsIndexRoute
  '/gigs/': typeof GigsIndexRoute
  '/mail/': typeof MailIndexRoute
  '/media/': typeof MediaIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/services/': typeof ServicesIndexRoute
  '/events/$eventId/checkout': typeof EventsEventIdCheckoutRoute
  '/events/$eventId/edit': typeof EventsEventIdEditRoute
  '/events/$eventId/edit-external': typeof EventsEventIdEditExternalRoute
  '/events/$eventId/success': typeof EventsEventIdSuccessRoute
  '/events/category/$filterName': typeof EventsCategoryFilterNameRoute
  '/events/create/external': typeof EventsCreateExternalRoute
  '/events/create/single': typeof EventsCreateSingleRoute
  '/gigs/$gigId/edit': typeof GigsGigIdEditRoute
  '/mail/broadcasts/$broadcastUuid': typeof MailBroadcastsBroadcastUuidRoute
  '/mail/lists/$listUuid': typeof MailListsListUuidRoute
  '/media/$mediaId/edit': typeof MediaMediaIdEditRoute
  '/offers/$offerId/chat': typeof OffersOfferIdChatRoute
  '/offers/$offerId/edit': typeof OffersOfferIdEditRoute
  '/offers/$offerId/shared-link': typeof OffersOfferIdSharedLinkRoute
  '/profile/settings/genres': typeof ProfileSettingsGenresRoute
  '/profile/settings/payments': typeof ProfileSettingsPaymentsRoute
  '/profile/settings/shareable-link': typeof ProfileSettingsShareableLinkRoute
  '/profile/settings/subscriptions': typeof ProfileSettingsSubscriptionsRoute
  '/profile/settings/tags': typeof ProfileSettingsTagsRoute
  '/profile/settings/user-type': typeof ProfileSettingsUserTypeRoute
  '/projects/$projectId/edit': typeof ProjectsProjectIdEditRoute
  '/projects/$projectId/notifications': typeof ProjectsProjectIdNotificationsRoute
  '/services/$serviceId/edit': typeof ServicesServiceIdEditRoute
  '/events/create/': typeof EventsCreateIndexRoute
  '/profile/settings/': typeof ProfileSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/check-email'
    | '/community-guidelines'
    | '/events'
    | '/forgot-password'
    | '/gigs'
    | '/help-support'
    | '/mail'
    | '/media'
    | '/messages'
    | '/music-style'
    | '/password-reset-success'
    | '/personal-information'
    | '/privacy-policy'
    | '/profile'
    | '/projects'
    | '/role-selection'
    | '/search-location'
    | '/services'
    | '/sign-in'
    | '/sign-up'
    | '/terms-of-service'
    | '/tickets'
    | '/user-filter'
    | '/verify-email'
    | '/checkout/cancel'
    | '/embedded_checkout_page/$eventId'
    | '/events/$eventId'
    | '/events/create'
    | '/events/public'
    | '/events/yours'
    | '/gigs/$gigId'
    | '/gigs/create'
    | '/mail/compose'
    | '/mail/contacts'
    | '/media/$mediaId'
    | '/media/create'
    | '/offers/$offerId'
    | '/offers/create'
    | '/profile/$identifier'
    | '/profile/change-password'
    | '/profile/edit'
    | '/profile/gig-requests'
    | '/profile/my-gigs'
    | '/profile/preferred-locations'
    | '/profile/settings'
    | '/projects/$projectId'
    | '/services/$serviceId'
    | '/services/create'
    | '/events/'
    | '/gigs/'
    | '/mail/'
    | '/media/'
    | '/profile/'
    | '/projects/'
    | '/services/'
    | '/events/$eventId/checkout'
    | '/events/$eventId/edit'
    | '/events/$eventId/edit-external'
    | '/events/$eventId/success'
    | '/events/category/$filterName'
    | '/events/create/external'
    | '/events/create/single'
    | '/gigs/$gigId/edit'
    | '/mail/broadcasts/$broadcastUuid'
    | '/mail/lists/$listUuid'
    | '/media/$mediaId/edit'
    | '/offers/$offerId/chat'
    | '/offers/$offerId/edit'
    | '/offers/$offerId/shared-link'
    | '/profile/settings/genres'
    | '/profile/settings/payments'
    | '/profile/settings/shareable-link'
    | '/profile/settings/subscriptions'
    | '/profile/settings/tags'
    | '/profile/settings/user-type'
    | '/projects/$projectId/edit'
    | '/projects/$projectId/notifications'
    | '/services/$serviceId/edit'
    | '/events/create/'
    | '/profile/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/check-email'
    | '/community-guidelines'
    | '/forgot-password'
    | '/help-support'
    | '/messages'
    | '/music-style'
    | '/password-reset-success'
    | '/personal-information'
    | '/privacy-policy'
    | '/role-selection'
    | '/search-location'
    | '/sign-in'
    | '/sign-up'
    | '/terms-of-service'
    | '/tickets'
    | '/user-filter'
    | '/verify-email'
    | '/checkout/cancel'
    | '/embedded_checkout_page/$eventId'
    | '/events/$eventId'
    | '/events/public'
    | '/events/yours'
    | '/gigs/$gigId'
    | '/gigs/create'
    | '/mail/compose'
    | '/mail/contacts'
    | '/media/$mediaId'
    | '/media/create'
    | '/offers/$offerId'
    | '/offers/create'
    | '/profile/$identifier'
    | '/profile/change-password'
    | '/profile/edit'
    | '/profile/gig-requests'
    | '/profile/my-gigs'
    | '/profile/preferred-locations'
    | '/projects/$projectId'
    | '/services/$serviceId'
    | '/services/create'
    | '/events'
    | '/gigs'
    | '/mail'
    | '/media'
    | '/profile'
    | '/projects'
    | '/services'
    | '/events/$eventId/checkout'
    | '/events/$eventId/edit'
    | '/events/$eventId/edit-external'
    | '/events/$eventId/success'
    | '/events/category/$filterName'
    | '/events/create/external'
    | '/events/create/single'
    | '/gigs/$gigId/edit'
    | '/mail/broadcasts/$broadcastUuid'
    | '/mail/lists/$listUuid'
    | '/media/$mediaId/edit'
    | '/offers/$offerId/chat'
    | '/offers/$offerId/edit'
    | '/offers/$offerId/shared-link'
    | '/profile/settings/genres'
    | '/profile/settings/payments'
    | '/profile/settings/shareable-link'
    | '/profile/settings/subscriptions'
    | '/profile/settings/tags'
    | '/profile/settings/user-type'
    | '/projects/$projectId/edit'
    | '/projects/$projectId/notifications'
    | '/services/$serviceId/edit'
    | '/events/create'
    | '/profile/settings'
  id:
    | '__root__'
    | '/'
    | '/check-email'
    | '/community-guidelines'
    | '/events'
    | '/forgot-password'
    | '/gigs'
    | '/help-support'
    | '/mail'
    | '/media'
    | '/messages'
    | '/music-style'
    | '/password-reset-success'
    | '/personal-information'
    | '/privacy-policy'
    | '/profile'
    | '/projects'
    | '/role-selection'
    | '/search-location'
    | '/services'
    | '/sign-in'
    | '/sign-up'
    | '/terms-of-service'
    | '/tickets'
    | '/user-filter'
    | '/verify-email'
    | '/checkout/cancel'
    | '/embedded_checkout_page/$eventId'
    | '/events/$eventId'
    | '/events/create'
    | '/events/public'
    | '/events/yours'
    | '/gigs/$gigId'
    | '/gigs/create'
    | '/mail/compose'
    | '/mail/contacts'
    | '/media/$mediaId'
    | '/media/create'
    | '/offers/$offerId'
    | '/offers/create'
    | '/profile/$identifier'
    | '/profile/change-password'
    | '/profile/edit'
    | '/profile/gig-requests'
    | '/profile/my-gigs'
    | '/profile/preferred-locations'
    | '/profile/settings'
    | '/projects/$projectId'
    | '/services/$serviceId'
    | '/services/create'
    | '/events/'
    | '/gigs/'
    | '/mail/'
    | '/media/'
    | '/profile/'
    | '/projects/'
    | '/services/'
    | '/events/$eventId/checkout'
    | '/events/$eventId/edit'
    | '/events/$eventId/edit-external'
    | '/events/$eventId/success'
    | '/events/category/$filterName'
    | '/events/create/external'
    | '/events/create/single'
    | '/gigs/$gigId/edit'
    | '/mail/broadcasts/$broadcastUuid'
    | '/mail/lists/$listUuid'
    | '/media/$mediaId/edit'
    | '/offers/$offerId/chat'
    | '/offers/$offerId/edit'
    | '/offers/$offerId/shared-link'
    | '/profile/settings/genres'
    | '/profile/settings/payments'
    | '/profile/settings/shareable-link'
    | '/profile/settings/subscriptions'
    | '/profile/settings/tags'
    | '/profile/settings/user-type'
    | '/projects/$projectId/edit'
    | '/projects/$projectId/notifications'
    | '/services/$serviceId/edit'
    | '/events/create/'
    | '/profile/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  CheckEmailRoute: typeof CheckEmailRoute
  CommunityGuidelinesRoute: typeof CommunityGuidelinesRoute
  EventsRoute: typeof EventsRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  GigsRoute: typeof GigsRouteWithChildren
  HelpSupportRoute: typeof HelpSupportRoute
  MailRoute: typeof MailRouteWithChildren
  MediaRoute: typeof MediaRouteWithChildren
  MessagesRoute: typeof MessagesRoute
  MusicStyleRoute: typeof MusicStyleRoute
  PasswordResetSuccessRoute: typeof PasswordResetSuccessRoute
  PersonalInformationRoute: typeof PersonalInformationRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  ProfileRoute: typeof ProfileRouteWithChildren
  ProjectsRoute: typeof ProjectsRouteWithChildren
  RoleSelectionRoute: typeof RoleSelectionRoute
  SearchLocationRoute: typeof SearchLocationRoute
  ServicesRoute: typeof ServicesRouteWithChildren
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  TicketsRoute: typeof TicketsRoute
  UserFilterRoute: typeof UserFilterRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  CheckoutCancelRoute: typeof CheckoutCancelRoute
  Embedded_checkout_pageEventIdRoute: typeof Embedded_checkout_pageEventIdRoute
  OffersOfferIdRoute: typeof OffersOfferIdRouteWithChildren
  OffersCreateRoute: typeof OffersCreateRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-filter': {
      id: '/user-filter'
      path: '/user-filter'
      fullPath: '/user-filter'
      preLoaderRoute: typeof UserFilterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets': {
      id: '/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof TicketsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services': {
      id: '/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof ServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search-location': {
      id: '/search-location'
      path: '/search-location'
      fullPath: '/search-location'
      preLoaderRoute: typeof SearchLocationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/role-selection': {
      id: '/role-selection'
      path: '/role-selection'
      fullPath: '/role-selection'
      preLoaderRoute: typeof RoleSelectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal-information': {
      id: '/personal-information'
      path: '/personal-information'
      fullPath: '/personal-information'
      preLoaderRoute: typeof PersonalInformationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset-success': {
      id: '/password-reset-success'
      path: '/password-reset-success'
      fullPath: '/password-reset-success'
      preLoaderRoute: typeof PasswordResetSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/music-style': {
      id: '/music-style'
      path: '/music-style'
      fullPath: '/music-style'
      preLoaderRoute: typeof MusicStyleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages': {
      id: '/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof MessagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media': {
      id: '/media'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof MediaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mail': {
      id: '/mail'
      path: '/mail'
      fullPath: '/mail'
      preLoaderRoute: typeof MailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help-support': {
      id: '/help-support'
      path: '/help-support'
      fullPath: '/help-support'
      preLoaderRoute: typeof HelpSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gigs': {
      id: '/gigs'
      path: '/gigs'
      fullPath: '/gigs'
      preLoaderRoute: typeof GigsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community-guidelines': {
      id: '/community-guidelines'
      path: '/community-guidelines'
      fullPath: '/community-guidelines'
      preLoaderRoute: typeof CommunityGuidelinesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/check-email': {
      id: '/check-email'
      path: '/check-email'
      fullPath: '/check-email'
      preLoaderRoute: typeof CheckEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/': {
      id: '/services/'
      path: '/'
      fullPath: '/services/'
      preLoaderRoute: typeof ServicesIndexRouteImport
      parentRoute: typeof ServicesRoute
    }
    '/projects/': {
      id: '/projects/'
      path: '/'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/profile/': {
      id: '/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/media/': {
      id: '/media/'
      path: '/'
      fullPath: '/media/'
      preLoaderRoute: typeof MediaIndexRouteImport
      parentRoute: typeof MediaRoute
    }
    '/mail/': {
      id: '/mail/'
      path: '/'
      fullPath: '/mail/'
      preLoaderRoute: typeof MailIndexRouteImport
      parentRoute: typeof MailRoute
    }
    '/gigs/': {
      id: '/gigs/'
      path: '/'
      fullPath: '/gigs/'
      preLoaderRoute: typeof GigsIndexRouteImport
      parentRoute: typeof GigsRoute
    }
    '/events/': {
      id: '/events/'
      path: '/'
      fullPath: '/events/'
      preLoaderRoute: typeof EventsIndexRouteImport
      parentRoute: typeof EventsRoute
    }
    '/services/create': {
      id: '/services/create'
      path: '/create'
      fullPath: '/services/create'
      preLoaderRoute: typeof ServicesCreateRouteImport
      parentRoute: typeof ServicesRoute
    }
    '/services/$serviceId': {
      id: '/services/$serviceId'
      path: '/$serviceId'
      fullPath: '/services/$serviceId'
      preLoaderRoute: typeof ServicesServiceIdRouteImport
      parentRoute: typeof ServicesRoute
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/profile/settings': {
      id: '/profile/settings'
      path: '/settings'
      fullPath: '/profile/settings'
      preLoaderRoute: typeof ProfileSettingsRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/preferred-locations': {
      id: '/profile/preferred-locations'
      path: '/preferred-locations'
      fullPath: '/profile/preferred-locations'
      preLoaderRoute: typeof ProfilePreferredLocationsRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/my-gigs': {
      id: '/profile/my-gigs'
      path: '/my-gigs'
      fullPath: '/profile/my-gigs'
      preLoaderRoute: typeof ProfileMyGigsRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/gig-requests': {
      id: '/profile/gig-requests'
      path: '/gig-requests'
      fullPath: '/profile/gig-requests'
      preLoaderRoute: typeof ProfileGigRequestsRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/edit': {
      id: '/profile/edit'
      path: '/edit'
      fullPath: '/profile/edit'
      preLoaderRoute: typeof ProfileEditRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/change-password': {
      id: '/profile/change-password'
      path: '/change-password'
      fullPath: '/profile/change-password'
      preLoaderRoute: typeof ProfileChangePasswordRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/$identifier': {
      id: '/profile/$identifier'
      path: '/$identifier'
      fullPath: '/profile/$identifier'
      preLoaderRoute: typeof ProfileIdentifierRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/offers/create': {
      id: '/offers/create'
      path: '/offers/create'
      fullPath: '/offers/create'
      preLoaderRoute: typeof OffersCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offers/$offerId': {
      id: '/offers/$offerId'
      path: '/offers/$offerId'
      fullPath: '/offers/$offerId'
      preLoaderRoute: typeof OffersOfferIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media/create': {
      id: '/media/create'
      path: '/create'
      fullPath: '/media/create'
      preLoaderRoute: typeof MediaCreateRouteImport
      parentRoute: typeof MediaRoute
    }
    '/media/$mediaId': {
      id: '/media/$mediaId'
      path: '/$mediaId'
      fullPath: '/media/$mediaId'
      preLoaderRoute: typeof MediaMediaIdRouteImport
      parentRoute: typeof MediaRoute
    }
    '/mail/contacts': {
      id: '/mail/contacts'
      path: '/contacts'
      fullPath: '/mail/contacts'
      preLoaderRoute: typeof MailContactsRouteImport
      parentRoute: typeof MailRoute
    }
    '/mail/compose': {
      id: '/mail/compose'
      path: '/compose'
      fullPath: '/mail/compose'
      preLoaderRoute: typeof MailComposeRouteImport
      parentRoute: typeof MailRoute
    }
    '/gigs/create': {
      id: '/gigs/create'
      path: '/create'
      fullPath: '/gigs/create'
      preLoaderRoute: typeof GigsCreateRouteImport
      parentRoute: typeof GigsRoute
    }
    '/gigs/$gigId': {
      id: '/gigs/$gigId'
      path: '/$gigId'
      fullPath: '/gigs/$gigId'
      preLoaderRoute: typeof GigsGigIdRouteImport
      parentRoute: typeof GigsRoute
    }
    '/events/yours': {
      id: '/events/yours'
      path: '/yours'
      fullPath: '/events/yours'
      preLoaderRoute: typeof EventsYoursRouteImport
      parentRoute: typeof EventsRoute
    }
    '/events/public': {
      id: '/events/public'
      path: '/public'
      fullPath: '/events/public'
      preLoaderRoute: typeof EventsPublicRouteImport
      parentRoute: typeof EventsRoute
    }
    '/events/create': {
      id: '/events/create'
      path: '/create'
      fullPath: '/events/create'
      preLoaderRoute: typeof EventsCreateRouteImport
      parentRoute: typeof EventsRoute
    }
    '/events/$eventId': {
      id: '/events/$eventId'
      path: '/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof EventsEventIdRouteImport
      parentRoute: typeof EventsRoute
    }
    '/embedded_checkout_page/$eventId': {
      id: '/embedded_checkout_page/$eventId'
      path: '/embedded_checkout_page/$eventId'
      fullPath: '/embedded_checkout_page/$eventId'
      preLoaderRoute: typeof Embedded_checkout_pageEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/cancel': {
      id: '/checkout/cancel'
      path: '/checkout/cancel'
      fullPath: '/checkout/cancel'
      preLoaderRoute: typeof CheckoutCancelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/settings/': {
      id: '/profile/settings/'
      path: '/'
      fullPath: '/profile/settings/'
      preLoaderRoute: typeof ProfileSettingsIndexRouteImport
      parentRoute: typeof ProfileSettingsRoute
    }
    '/events/create/': {
      id: '/events/create/'
      path: '/'
      fullPath: '/events/create/'
      preLoaderRoute: typeof EventsCreateIndexRouteImport
      parentRoute: typeof EventsCreateRoute
    }
    '/services/$serviceId/edit': {
      id: '/services/$serviceId/edit'
      path: '/edit'
      fullPath: '/services/$serviceId/edit'
      preLoaderRoute: typeof ServicesServiceIdEditRouteImport
      parentRoute: typeof ServicesServiceIdRoute
    }
    '/projects/$projectId/notifications': {
      id: '/projects/$projectId/notifications'
      path: '/notifications'
      fullPath: '/projects/$projectId/notifications'
      preLoaderRoute: typeof ProjectsProjectIdNotificationsRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/edit': {
      id: '/projects/$projectId/edit'
      path: '/edit'
      fullPath: '/projects/$projectId/edit'
      preLoaderRoute: typeof ProjectsProjectIdEditRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/profile/settings/user-type': {
      id: '/profile/settings/user-type'
      path: '/user-type'
      fullPath: '/profile/settings/user-type'
      preLoaderRoute: typeof ProfileSettingsUserTypeRouteImport
      parentRoute: typeof ProfileSettingsRoute
    }
    '/profile/settings/tags': {
      id: '/profile/settings/tags'
      path: '/tags'
      fullPath: '/profile/settings/tags'
      preLoaderRoute: typeof ProfileSettingsTagsRouteImport
      parentRoute: typeof ProfileSettingsRoute
    }
    '/profile/settings/subscriptions': {
      id: '/profile/settings/subscriptions'
      path: '/subscriptions'
      fullPath: '/profile/settings/subscriptions'
      preLoaderRoute: typeof ProfileSettingsSubscriptionsRouteImport
      parentRoute: typeof ProfileSettingsRoute
    }
    '/profile/settings/shareable-link': {
      id: '/profile/settings/shareable-link'
      path: '/shareable-link'
      fullPath: '/profile/settings/shareable-link'
      preLoaderRoute: typeof ProfileSettingsShareableLinkRouteImport
      parentRoute: typeof ProfileSettingsRoute
    }
    '/profile/settings/payments': {
      id: '/profile/settings/payments'
      path: '/payments'
      fullPath: '/profile/settings/payments'
      preLoaderRoute: typeof ProfileSettingsPaymentsRouteImport
      parentRoute: typeof ProfileSettingsRoute
    }
    '/profile/settings/genres': {
      id: '/profile/settings/genres'
      path: '/genres'
      fullPath: '/profile/settings/genres'
      preLoaderRoute: typeof ProfileSettingsGenresRouteImport
      parentRoute: typeof ProfileSettingsRoute
    }
    '/offers/$offerId/shared-link': {
      id: '/offers/$offerId/shared-link'
      path: '/shared-link'
      fullPath: '/offers/$offerId/shared-link'
      preLoaderRoute: typeof OffersOfferIdSharedLinkRouteImport
      parentRoute: typeof OffersOfferIdRoute
    }
    '/offers/$offerId/edit': {
      id: '/offers/$offerId/edit'
      path: '/edit'
      fullPath: '/offers/$offerId/edit'
      preLoaderRoute: typeof OffersOfferIdEditRouteImport
      parentRoute: typeof OffersOfferIdRoute
    }
    '/offers/$offerId/chat': {
      id: '/offers/$offerId/chat'
      path: '/chat'
      fullPath: '/offers/$offerId/chat'
      preLoaderRoute: typeof OffersOfferIdChatRouteImport
      parentRoute: typeof OffersOfferIdRoute
    }
    '/media/$mediaId/edit': {
      id: '/media/$mediaId/edit'
      path: '/edit'
      fullPath: '/media/$mediaId/edit'
      preLoaderRoute: typeof MediaMediaIdEditRouteImport
      parentRoute: typeof MediaMediaIdRoute
    }
    '/mail/lists/$listUuid': {
      id: '/mail/lists/$listUuid'
      path: '/lists/$listUuid'
      fullPath: '/mail/lists/$listUuid'
      preLoaderRoute: typeof MailListsListUuidRouteImport
      parentRoute: typeof MailRoute
    }
    '/mail/broadcasts/$broadcastUuid': {
      id: '/mail/broadcasts/$broadcastUuid'
      path: '/broadcasts/$broadcastUuid'
      fullPath: '/mail/broadcasts/$broadcastUuid'
      preLoaderRoute: typeof MailBroadcastsBroadcastUuidRouteImport
      parentRoute: typeof MailRoute
    }
    '/gigs/$gigId/edit': {
      id: '/gigs/$gigId/edit'
      path: '/edit'
      fullPath: '/gigs/$gigId/edit'
      preLoaderRoute: typeof GigsGigIdEditRouteImport
      parentRoute: typeof GigsGigIdRoute
    }
    '/events/create/single': {
      id: '/events/create/single'
      path: '/single'
      fullPath: '/events/create/single'
      preLoaderRoute: typeof EventsCreateSingleRouteImport
      parentRoute: typeof EventsCreateRoute
    }
    '/events/create/external': {
      id: '/events/create/external'
      path: '/external'
      fullPath: '/events/create/external'
      preLoaderRoute: typeof EventsCreateExternalRouteImport
      parentRoute: typeof EventsCreateRoute
    }
    '/events/category/$filterName': {
      id: '/events/category/$filterName'
      path: '/category/$filterName'
      fullPath: '/events/category/$filterName'
      preLoaderRoute: typeof EventsCategoryFilterNameRouteImport
      parentRoute: typeof EventsRoute
    }
    '/events/$eventId/success': {
      id: '/events/$eventId/success'
      path: '/success'
      fullPath: '/events/$eventId/success'
      preLoaderRoute: typeof EventsEventIdSuccessRouteImport
      parentRoute: typeof EventsEventIdRoute
    }
    '/events/$eventId/edit-external': {
      id: '/events/$eventId/edit-external'
      path: '/edit-external'
      fullPath: '/events/$eventId/edit-external'
      preLoaderRoute: typeof EventsEventIdEditExternalRouteImport
      parentRoute: typeof EventsEventIdRoute
    }
    '/events/$eventId/edit': {
      id: '/events/$eventId/edit'
      path: '/edit'
      fullPath: '/events/$eventId/edit'
      preLoaderRoute: typeof EventsEventIdEditRouteImport
      parentRoute: typeof EventsEventIdRoute
    }
    '/events/$eventId/checkout': {
      id: '/events/$eventId/checkout'
      path: '/checkout'
      fullPath: '/events/$eventId/checkout'
      preLoaderRoute: typeof EventsEventIdCheckoutRouteImport
      parentRoute: typeof EventsEventIdRoute
    }
  }
}

interface EventsEventIdRouteChildren {
  EventsEventIdCheckoutRoute: typeof EventsEventIdCheckoutRoute
  EventsEventIdEditRoute: typeof EventsEventIdEditRoute
  EventsEventIdEditExternalRoute: typeof EventsEventIdEditExternalRoute
  EventsEventIdSuccessRoute: typeof EventsEventIdSuccessRoute
}

const EventsEventIdRouteChildren: EventsEventIdRouteChildren = {
  EventsEventIdCheckoutRoute: EventsEventIdCheckoutRoute,
  EventsEventIdEditRoute: EventsEventIdEditRoute,
  EventsEventIdEditExternalRoute: EventsEventIdEditExternalRoute,
  EventsEventIdSuccessRoute: EventsEventIdSuccessRoute,
}

const EventsEventIdRouteWithChildren = EventsEventIdRoute._addFileChildren(
  EventsEventIdRouteChildren,
)

interface EventsCreateRouteChildren {
  EventsCreateExternalRoute: typeof EventsCreateExternalRoute
  EventsCreateSingleRoute: typeof EventsCreateSingleRoute
  EventsCreateIndexRoute: typeof EventsCreateIndexRoute
}

const EventsCreateRouteChildren: EventsCreateRouteChildren = {
  EventsCreateExternalRoute: EventsCreateExternalRoute,
  EventsCreateSingleRoute: EventsCreateSingleRoute,
  EventsCreateIndexRoute: EventsCreateIndexRoute,
}

const EventsCreateRouteWithChildren = EventsCreateRoute._addFileChildren(
  EventsCreateRouteChildren,
)

interface EventsRouteChildren {
  EventsEventIdRoute: typeof EventsEventIdRouteWithChildren
  EventsCreateRoute: typeof EventsCreateRouteWithChildren
  EventsPublicRoute: typeof EventsPublicRoute
  EventsYoursRoute: typeof EventsYoursRoute
  EventsIndexRoute: typeof EventsIndexRoute
  EventsCategoryFilterNameRoute: typeof EventsCategoryFilterNameRoute
}

const EventsRouteChildren: EventsRouteChildren = {
  EventsEventIdRoute: EventsEventIdRouteWithChildren,
  EventsCreateRoute: EventsCreateRouteWithChildren,
  EventsPublicRoute: EventsPublicRoute,
  EventsYoursRoute: EventsYoursRoute,
  EventsIndexRoute: EventsIndexRoute,
  EventsCategoryFilterNameRoute: EventsCategoryFilterNameRoute,
}

const EventsRouteWithChildren =
  EventsRoute._addFileChildren(EventsRouteChildren)

interface GigsGigIdRouteChildren {
  GigsGigIdEditRoute: typeof GigsGigIdEditRoute
}

const GigsGigIdRouteChildren: GigsGigIdRouteChildren = {
  GigsGigIdEditRoute: GigsGigIdEditRoute,
}

const GigsGigIdRouteWithChildren = GigsGigIdRoute._addFileChildren(
  GigsGigIdRouteChildren,
)

interface GigsRouteChildren {
  GigsGigIdRoute: typeof GigsGigIdRouteWithChildren
  GigsCreateRoute: typeof GigsCreateRoute
  GigsIndexRoute: typeof GigsIndexRoute
}

const GigsRouteChildren: GigsRouteChildren = {
  GigsGigIdRoute: GigsGigIdRouteWithChildren,
  GigsCreateRoute: GigsCreateRoute,
  GigsIndexRoute: GigsIndexRoute,
}

const GigsRouteWithChildren = GigsRoute._addFileChildren(GigsRouteChildren)

interface MailRouteChildren {
  MailComposeRoute: typeof MailComposeRoute
  MailContactsRoute: typeof MailContactsRoute
  MailIndexRoute: typeof MailIndexRoute
  MailBroadcastsBroadcastUuidRoute: typeof MailBroadcastsBroadcastUuidRoute
  MailListsListUuidRoute: typeof MailListsListUuidRoute
}

const MailRouteChildren: MailRouteChildren = {
  MailComposeRoute: MailComposeRoute,
  MailContactsRoute: MailContactsRoute,
  MailIndexRoute: MailIndexRoute,
  MailBroadcastsBroadcastUuidRoute: MailBroadcastsBroadcastUuidRoute,
  MailListsListUuidRoute: MailListsListUuidRoute,
}

const MailRouteWithChildren = MailRoute._addFileChildren(MailRouteChildren)

interface MediaMediaIdRouteChildren {
  MediaMediaIdEditRoute: typeof MediaMediaIdEditRoute
}

const MediaMediaIdRouteChildren: MediaMediaIdRouteChildren = {
  MediaMediaIdEditRoute: MediaMediaIdEditRoute,
}

const MediaMediaIdRouteWithChildren = MediaMediaIdRoute._addFileChildren(
  MediaMediaIdRouteChildren,
)

interface MediaRouteChildren {
  MediaMediaIdRoute: typeof MediaMediaIdRouteWithChildren
  MediaCreateRoute: typeof MediaCreateRoute
  MediaIndexRoute: typeof MediaIndexRoute
}

const MediaRouteChildren: MediaRouteChildren = {
  MediaMediaIdRoute: MediaMediaIdRouteWithChildren,
  MediaCreateRoute: MediaCreateRoute,
  MediaIndexRoute: MediaIndexRoute,
}

const MediaRouteWithChildren = MediaRoute._addFileChildren(MediaRouteChildren)

interface ProfileSettingsRouteChildren {
  ProfileSettingsGenresRoute: typeof ProfileSettingsGenresRoute
  ProfileSettingsPaymentsRoute: typeof ProfileSettingsPaymentsRoute
  ProfileSettingsShareableLinkRoute: typeof ProfileSettingsShareableLinkRoute
  ProfileSettingsSubscriptionsRoute: typeof ProfileSettingsSubscriptionsRoute
  ProfileSettingsTagsRoute: typeof ProfileSettingsTagsRoute
  ProfileSettingsUserTypeRoute: typeof ProfileSettingsUserTypeRoute
  ProfileSettingsIndexRoute: typeof ProfileSettingsIndexRoute
}

const ProfileSettingsRouteChildren: ProfileSettingsRouteChildren = {
  ProfileSettingsGenresRoute: ProfileSettingsGenresRoute,
  ProfileSettingsPaymentsRoute: ProfileSettingsPaymentsRoute,
  ProfileSettingsShareableLinkRoute: ProfileSettingsShareableLinkRoute,
  ProfileSettingsSubscriptionsRoute: ProfileSettingsSubscriptionsRoute,
  ProfileSettingsTagsRoute: ProfileSettingsTagsRoute,
  ProfileSettingsUserTypeRoute: ProfileSettingsUserTypeRoute,
  ProfileSettingsIndexRoute: ProfileSettingsIndexRoute,
}

const ProfileSettingsRouteWithChildren = ProfileSettingsRoute._addFileChildren(
  ProfileSettingsRouteChildren,
)

interface ProfileRouteChildren {
  ProfileIdentifierRoute: typeof ProfileIdentifierRoute
  ProfileChangePasswordRoute: typeof ProfileChangePasswordRoute
  ProfileEditRoute: typeof ProfileEditRoute
  ProfileGigRequestsRoute: typeof ProfileGigRequestsRoute
  ProfileMyGigsRoute: typeof ProfileMyGigsRoute
  ProfilePreferredLocationsRoute: typeof ProfilePreferredLocationsRoute
  ProfileSettingsRoute: typeof ProfileSettingsRouteWithChildren
  ProfileIndexRoute: typeof ProfileIndexRoute
}

const ProfileRouteChildren: ProfileRouteChildren = {
  ProfileIdentifierRoute: ProfileIdentifierRoute,
  ProfileChangePasswordRoute: ProfileChangePasswordRoute,
  ProfileEditRoute: ProfileEditRoute,
  ProfileGigRequestsRoute: ProfileGigRequestsRoute,
  ProfileMyGigsRoute: ProfileMyGigsRoute,
  ProfilePreferredLocationsRoute: ProfilePreferredLocationsRoute,
  ProfileSettingsRoute: ProfileSettingsRouteWithChildren,
  ProfileIndexRoute: ProfileIndexRoute,
}

const ProfileRouteWithChildren =
  ProfileRoute._addFileChildren(ProfileRouteChildren)

interface ProjectsProjectIdRouteChildren {
  ProjectsProjectIdEditRoute: typeof ProjectsProjectIdEditRoute
  ProjectsProjectIdNotificationsRoute: typeof ProjectsProjectIdNotificationsRoute
}

const ProjectsProjectIdRouteChildren: ProjectsProjectIdRouteChildren = {
  ProjectsProjectIdEditRoute: ProjectsProjectIdEditRoute,
  ProjectsProjectIdNotificationsRoute: ProjectsProjectIdNotificationsRoute,
}

const ProjectsProjectIdRouteWithChildren =
  ProjectsProjectIdRoute._addFileChildren(ProjectsProjectIdRouteChildren)

interface ProjectsRouteChildren {
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRouteWithChildren
  ProjectsIndexRoute: typeof ProjectsIndexRoute
}

const ProjectsRouteChildren: ProjectsRouteChildren = {
  ProjectsProjectIdRoute: ProjectsProjectIdRouteWithChildren,
  ProjectsIndexRoute: ProjectsIndexRoute,
}

const ProjectsRouteWithChildren = ProjectsRoute._addFileChildren(
  ProjectsRouteChildren,
)

interface ServicesServiceIdRouteChildren {
  ServicesServiceIdEditRoute: typeof ServicesServiceIdEditRoute
}

const ServicesServiceIdRouteChildren: ServicesServiceIdRouteChildren = {
  ServicesServiceIdEditRoute: ServicesServiceIdEditRoute,
}

const ServicesServiceIdRouteWithChildren =
  ServicesServiceIdRoute._addFileChildren(ServicesServiceIdRouteChildren)

interface ServicesRouteChildren {
  ServicesServiceIdRoute: typeof ServicesServiceIdRouteWithChildren
  ServicesCreateRoute: typeof ServicesCreateRoute
  ServicesIndexRoute: typeof ServicesIndexRoute
}

const ServicesRouteChildren: ServicesRouteChildren = {
  ServicesServiceIdRoute: ServicesServiceIdRouteWithChildren,
  ServicesCreateRoute: ServicesCreateRoute,
  ServicesIndexRoute: ServicesIndexRoute,
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(
  ServicesRouteChildren,
)

interface OffersOfferIdRouteChildren {
  OffersOfferIdChatRoute: typeof OffersOfferIdChatRoute
  OffersOfferIdEditRoute: typeof OffersOfferIdEditRoute
  OffersOfferIdSharedLinkRoute: typeof OffersOfferIdSharedLinkRoute
}

const OffersOfferIdRouteChildren: OffersOfferIdRouteChildren = {
  OffersOfferIdChatRoute: OffersOfferIdChatRoute,
  OffersOfferIdEditRoute: OffersOfferIdEditRoute,
  OffersOfferIdSharedLinkRoute: OffersOfferIdSharedLinkRoute,
}

const OffersOfferIdRouteWithChildren = OffersOfferIdRoute._addFileChildren(
  OffersOfferIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  CheckEmailRoute: CheckEmailRoute,
  CommunityGuidelinesRoute: CommunityGuidelinesRoute,
  EventsRoute: EventsRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  GigsRoute: GigsRouteWithChildren,
  HelpSupportRoute: HelpSupportRoute,
  MailRoute: MailRouteWithChildren,
  MediaRoute: MediaRouteWithChildren,
  MessagesRoute: MessagesRoute,
  MusicStyleRoute: MusicStyleRoute,
  PasswordResetSuccessRoute: PasswordResetSuccessRoute,
  PersonalInformationRoute: PersonalInformationRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ProfileRoute: ProfileRouteWithChildren,
  ProjectsRoute: ProjectsRouteWithChildren,
  RoleSelectionRoute: RoleSelectionRoute,
  SearchLocationRoute: SearchLocationRoute,
  ServicesRoute: ServicesRouteWithChildren,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  TicketsRoute: TicketsRoute,
  UserFilterRoute: UserFilterRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  CheckoutCancelRoute: CheckoutCancelRoute,
  Embedded_checkout_pageEventIdRoute: Embedded_checkout_pageEventIdRoute,
  OffersOfferIdRoute: OffersOfferIdRouteWithChildren,
  OffersCreateRoute: OffersCreateRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
